export default __webpack_public_path__ + "static/media/nuvensDesipadas.1dcfdc84.svg";